/*
 *   File : select-dropdown.js
 *   Author : https://evoqins.com
 *   Description : Select dropdown that opens its options below the field
 *   Integrations : NA
 *   Version : 1.0.0
*/

// *********** React Core ***************//
import { useState, useEffect, useRef } from "react";

// *********** Components ***************//
import { Icon } from "../Icon";

// *********** Styles ***************//
import Style from "../../Style/Component/dropdown.module.scss";

const SelectDropdown = (props) => {

    const dropdownRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    // Closes the options on a click outside the dropdown or on Escape
    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const _handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        const _handleEscape = (event) => {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", _handleOutsideClick);
        document.addEventListener("keydown", _handleEscape);

        return () => {
            document.removeEventListener("mousedown", _handleOutsideClick);
            document.removeEventListener("keydown", _handleEscape);
        };
    }, [isOpen]);

    const _handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const _handleSelect = (option) => {
        props.onSelectOption(option);
        setIsOpen(false);
    };

    return (
        <div ref={dropdownRef} className={`position-relative ${props.className ?? ""}`}>
            <button id={props.id}
                type="button"
                className="d-flex justify-content-between align-items-center w-100 e-bg-white e-border-1px-gainsboro-gray e-border-radius-12 padding-12px-lr padding-12px-tb cursor-pointer no-outline e-text-eerie-black e-primary-font-inter e-font-weight-500 e-font-16 line-height-22px"
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                onClick={_handleToggle}>
                {props.selectedOption?.display_name}
                <Icon icon="down-arrow"
                    size={24}
                    className={`${Style.arrow} ${isOpen ? Style.arrow_open : ""}`} />
            </button>

            {
                isOpen &&
                <ul className={`${Style.options} position-absolute top-100 start-0 w-100 list-unstyled mt-1 mb-0 py-2 overflow-auto h-max-500px e-bg-white e-border-1px-gainsboro-gray e-border-radius-12 e-box-shadow-soft-card`}
                    role="listbox"
                    aria-labelledby={props.id}>
                    {
                        props.data.map((option) => (
                            <li key={option.id}
                                role="option"
                                tabIndex={0}
                                aria-selected={props.selectedOption?.id === option.id}
                                className={`${Style.option} padding-12px-lr padding-12px-tb cursor-pointer no-outline e-primary-font-inter e-font-weight-500 e-font-16 line-height-22px ${props.selectedOption?.id === option.id ? "e-text-egyptian-blue" : "e-text-sonic-silver"}`}
                                onClick={() => _handleSelect(option)}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        _handleSelect(option);
                                    }
                                }}>
                                {option.display_name}
                            </li>
                        ))
                    }
                </ul>
            }
        </div>
    );
};

export default SelectDropdown;
